import React from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';

// Constants

import { checkUserStatus, USER_GROUP_ROLES } from '@constants/roles/userRoleTypes';
import { UPLOADED_DOCUMENT_STATUSES } from '@constants/common/miscellaneous';

const DocumentOverride = props => {
    const {
        categoryType,
        handleOverrideClick,
        overrideDone,
        receivedDocumentTypes,
        userRole
    } = props;

    const isSuperUser = checkUserStatus(USER_GROUP_ROLES.SUPERUSERS, userRole);

    const nonOverridableStatuses = [
        UPLOADED_DOCUMENT_STATUSES.INITIAL,
        UPLOADED_DOCUMENT_STATUSES.VERIFIED,
        UPLOADED_DOCUMENT_STATUSES.SUBMITTED
    ];

    const checkIfNonOverridableStatus = status => nonOverridableStatuses
        .some(nonOverridableStatus => nonOverridableStatus === status);

    const isAbleToBeOverridden = !receivedDocumentTypes
        .some(d => checkIfNonOverridableStatus(d.documentStatus)) && !overrideDone;

    if(isSuperUser && isAbleToBeOverridden) {

        return (
            <Button
                className = 'gi-button gi-button__outline pull-right'
                onClick = { () => handleOverrideClick(categoryType) }
            >
                <FormattedMessage id = 'button.override'/>
            </Button>
        );
    } else {
        return null;
    }
};

export default DocumentOverride;